import { defineNuxtPlugin, useRoute } from '#app'

export default defineNuxtPlugin({
  name: 'paramTracking',
  dependsOn: ['is-web-frontend-hostname'],
  setup(nuxtApp) {
    const { $isWebFrontendHostname } = nuxtApp

    if (
      // This value is set by `modules/core/plugins/isWebFrontendHostname.js`, and will be true
      // if the routes are related to the tool and not the publisher website.
      // We don't want to load the script for published websites.
      !$isWebFrontendHostname
    ) {
      return
    }

    const route = useRoute()

    // Keep in sync with
    // `plugins/saas/backend/src/saas/pipedrive/api.py::get_track_custom_fields_data::param_to_field_id`
    // and the `click_id_param` of the backend `AdConversionPlatformType`s.
    const allowedParams = [
      'gclid',
      'li_fat_id',
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ]

    const captured = {}
    Object.keys(route.query).forEach((key) => {
      const lowerCaseKey = key.toLowerCase()
      if (allowedParams.includes(lowerCaseKey)) {
        captured[lowerCaseKey] = route.query[key]
      }
    })

    try {
      const stored = JSON.parse(localStorage.getItem('trackedParams') || '{}')
      const updated = { ...stored, ...captured }
      localStorage.setItem('trackedParams', JSON.stringify(updated))
    } catch (e) {
      console.error('Failed to update localStorage:', e)
    }
  },
})
